$.fn.modal.Constructor.prototype.enforceFocus = function() {};

$(function() {
    const dropdownList = $('.nav-item>a[href="/theatres"]').parent().find(".dropdown");
    const dropdownItems = dropdownList.children()
    let heightList = 0;
    if(dropdownItems.length > 8) {
        const listGap = parseInt(dropdownList.css("row-gap"));
        dropdownItems.map((index, item)=>{
            if(index < 8) {
                heightList += $(item).outerHeight() + listGap;
            }
        })
        const listPadding = parseInt(dropdownList.css("padding").split(" ")[0]);
        heightList += listPadding;
        dropdownList.css("overflow-y", "scroll").css("height", heightList)
    }
})

$(".page").on("click", ".add-to-fav", function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    $.ajax({
        url: "/favorite/add",
        method: "post",
        data: {filmId: $target.data("film-id")},
        beforeSend: function () {
            $target.removeClass("add-to-fav").addClass("remove-from-fav");
        }
    })
        .done(function (response) {
            if (response) {
                $target.data("fav-id", response);
            } else {
                $target.addClass("add-to-fav").removeClass("remove-from-fav");
            }
        })
        .fail(function () {
            console.log("error on adding film to favorite");
        });
});

$(".page").on("click", ".remove-from-fav", function (e) {
    e.preventDefault();
    var $target = $(e.currentTarget);
    $.ajax({
        url: "/favorite/remove",
        method: "post",
        data: {favId: $target.data("fav-id")},
        beforeSend: function () {
            $target.removeClass("remove-from-fav").addClass("add-to-fav");
        }
    })
        .done(function (response) {
            if (!response) {
                $target.addClass("remove-from-fav").removeClass("add-to-fav");
            } else {
                $target.removeData("data-fav-id");
            }
        })
        .fail(function () {
            console.log("error on adding film to favorite");
        });
});

$(document).on("click", ".city-tooltip__close", function (e) {
    e.preventDefault();
    $.ajax({
        url: "/site/stop-geo",
        method: "post"
    })
        .done(function (response) {
            $(".city-tooltip__close")
                .parents(".city-tooltip")
                .fadeOut();
        })
        .fail(function () {
            console.log("error on adding film to favorite");
        });
});

$(document).on("click", ".reset-cookies", function () {
    $.ajax({
        url: "/site/reset-cookies",
        method: "post"
    })
        .done(function (response) {
            // console.log('success');
            // window.location.reload();
        })
        .fail(function () {
            console.log("error on resetting cookies");
        });
});

$(document).on("click", ".orders-history button", function (e) {
    var $target = $(e.currentTarget);
    $($target).next().addClass('hide');
    $.ajax({
        url: "/user/cabinet/cancel-order",
        method: "post",
        data: {ticketReservationId: $target.data('ticket-order'), barReservationId: $target.data('bar-order')}
    })
    .done(function (response) {
        $($target).next().removeClass().addClass(response.success ? 'text-success' : 'text-danger').text(response.message);
        if (response.success) {
            $target.parents('.orders-history__item').find('.orders-history__number-state').html('<span class="number-state__bullet state-bullet-violet"></span> Возвращён');
            $target.hide();
        }
    })
    .fail(function () {
        console.log("error on order cancelling");
    });
});

$(document).on("click", '[data-adult-check="true"]', function (e) {
    e.preventDefault();

    var targetUrl = $(e.currentTarget).attr("href");
    $("#adultModal").modal("show");
    $("#adultModal")
        .on("click", ".redirect-forward", function (e) {
            e.preventDefault();
            $.ajax({
                method: "get",
                url: "/site/set-adult"
            }).done(function (response) {
                if (response) {
                    window.location.href = targetUrl;
                }
            });
        })
        .on("click", ".redirect-back", function (e) {
            e.preventDefault();
            $("#adultModal").modal("hide");
        });
});

checkAdultOnLoad();

$("#cityModal")
    .off("show.bs.modal")
    .on("show.bs.modal", function () {
        $("#suggest-city__form input[name=suggest-city]").on("change keyup", function () {
            var value = $(this).val().toLowerCase();
            $(".city-picker__list a").each(function () {
                if ($(this).text().toLowerCase().search(value) != -1)
                    $(this).show();
                else
                    $(this).hide();
            });
            $(".city-picker__group").show().each(function () {
                if ($(this).find("li a:visible").length)
                    $(this).show();
                else
                    $(this).hide();
            });
        });

        $.ajax({
            url: "/location/get-force",
            method: "get"
        })
            .done(function (response) {
                console.log(response);
                if (response.city.status && response.city.data) {
                    var data = response.city.data;
                    if (data) {
                        renderCityTooltips(data, response.defaultCity);
                    }
                }
            })
            .fail(function () {
                console.log("network error");
            });
        var renderCityTooltips = function (data, defaultCityId) {
            var alias =
                /*defaultCityId === data.city.id ? '/' :*/ "/set-city/" +
                data.city.alias;

            $(".suggest .suggest__value")
                .attr({
                    href: alias
                })
                .find(".text-border-gradient__text")
                .text(data.city.name);
        };
    });

function checkAdultOnLoad() {
    var checkAdult = $('[data-adult-load="true"]').length > 0;
    if (checkAdult) {
        $("#adultModal").modal("show");
        $("#adultModal")
            .on("click", ".redirect-forward", function (e) {
                e.preventDefault();
                $.ajax({
                    method: "get",
                    url: "/site/set-adult"
                }).done(function (response) {
                    if (response) {
                        $("#adultModal").modal("hide");
                    }
                });
            })
            .on("click", ".redirect-back", function (e) {
                e.preventDefault();
                history.go(-1);
            });
    }
}

var renderData = function (data) {
    var lists = data.result;
    var currentData = data.currentData;

    renderList(lists["districtList"], currentData.districtId, "district");
    renderList(lists["regionList"], currentData.regionId, "region");
    renderList(
        lists["cityList"],
        currentData.cityId,
        "city",
        currentData.defaultCityId
    );
    $("#suggest-city__form").data("default", currentData.defaultCityAlias);
};

var renderList = function (items, currentValue, listName, defaultValue = null) {
    var $list = $(`.city-picker__list[data-list=${listName}]`);
    $list.html("");
    Object.values(items).forEach(entry => {
        var isActiveClass =
            entry.id === currentValue ? " text-border-gradient_active" : "";

        var li = $("<li>").appendTo($list);
        var a = $("<a>", {
            class: "text-border-gradient" + isActiveClass,
            href:
                listName === "city"
                    ? /*defaultValue === entry.id ? '/' : */ "/set-city/" + entry.alias
                    : "",
            data: {
                id: entry.id
            }
        }).appendTo(li);
        $("<span>", {
            text: entry.name,
            class: "text-border-gradient__text"
        }).appendTo(a);
    });
};

$(".toggle-password-input").on("click", function (e) {
    var $target = $(e.currentTarget),
        $input = $target.parent().find("input");
    var inputType = $input.attr("type"),
        newType = inputType === "password" ? "text" : "password";

    $input.attr("type", newType);
});

function initPlayer() {
    $(".jwplayer-trailer").each((index, item) => {
        let $item = $(item),
            itemId = $(item).attr("id"),
            itemHeight = $(item).data("height");

        if (!itemId) {
            itemId = "jwplayer" + index;
            $item.attr("id", itemId);
        }
        jwplayer(itemId).setup({
            width: "100%",
            height: itemHeight ? itemHeight : 320,
            file: $item.data("video"),
            image: $item.data("poster")
        });
    });
}

initPlayer();

$("#player-init").on("pjax:success", function () {
    initPlayer();
});

initCompleteRegistration();
initMapCard();
initProfile();

function initProfile() {
    var form$ = $("#formProfile");
    var countdownWrapper$ = $(".wrapperCountdown", form$);
    var countdown$ = $("#sms-countdown", countdownWrapper$);
    var ttl = countdownWrapper$.data("ttl") || 0;

    form$.find("div.sms-resend").hide();

    $("input[name='ProfileForm[gender]']:radio", form$).on("change", function (e) {
        var val = $("input[name='ProfileForm[gender]']:radio:checked", form$).val();
        form$.find("input[name='ProfileForm[gender]'][type=hidden]").val(val);
    });

    $("input[name='ProfileForm[code]']", form$).on("keydown", function (e) {
        if (e.which === 13) {
            e.preventDefault();
            form$.find('button[data-action="form-sms"]').trigger("click");
        }
    });

    var addField = function (formData, name, filter) {
        var key = "ProfileForm[" + name + "]";
        var field$ = form$.find("[name='ProfileForm[" + name + "]']");
        field$ = filter ? field$.filter(filter) : field$;
        formData.set(key, field$.val());
        return field$.val();
    };

    $("button[data-action='form-sms']", form$).on("click", function (e) {
        var _this = $(this);
        e.preventDefault();

        var onDone = function (response) {
            if (response.success === true) {
                location.reload();
            } else {
                displayResponseErrors(response, "ProfileForm", form$);
            }
        };
        var data = new FormData();
        addField(data, "username");
        addField(data, "name");
        addField(data, "email");
        addField(data, "phone");
        addField(data, "gender");
        addField(data, "birthday");
        addField(data, "image");
        addField(data, "code");
        data.set("_csrf", form$.find("[name='_csrf']").val());

        var url = form$.attr("action");
        sendAjaxRequest(_this, form$, url, "post", data, onDone);
    });

    $("button[data-action='form-send']", form$).on("click", function (e) {
        var _this = $(this);
        e.preventDefault();

        countdownWrapper$.hide();
        form$.find("div.sms-resend").hide();

        var data = new FormData();
        addField(data, "username");
        addField(data, "name");
        addField(data, "email");
        addField(data, "phone");
        addField(data, "gender");
        addField(data, "birthday");
        addField(data, "image");
        data.set("_csrf", form$.find("[name='_csrf']").val());

        var onDone = function (response) {
            if (response.success === true) {
                var url = form$.attr("action");
                var onDone = function (response) {
                    if (response.success === true) {
                        location.reload();
                    } else {
                        displayResponseErrors(response, "ProfileForm", form$);
                    }
                };
                sendAjaxRequest(_this, form$, url, "post", data, onDone);
            } else if (response.smscode) {
                form$
                    .find(".sms-code")
                    .closest(".form-group")
                    .find("label")
                    .html(response.message);
                form$.find(".field-profileform-code").show();
                form$
                    .find("button[data-action='form-sms']")
                    .css({display: "flex"})
                    .show();
                form$.find("button[data-action='form-send']").hide();
                countdownWrapper$.show();
                countdown$.countdown($.now() + ttl * 60 * 1000);
                countdown$.on("finish.countdown", function (e) {
                    onCountDownFinished(form$, "button[data-action='form-send']");
                });
                countdownWrapper$.insertBefore("#profileform-code");
            } else {
                displayResponseErrors(response, "ProfileForm", form$);
            }
        };

        var url = "/user/cabinet/validate-profile";
        sendAjaxRequest(_this, form$, url, "post", data, onDone);
    });
}

function onCountDownFinished(_form$, sendSmsSelector) {
    //debugger;
    _form$.find("div.sms-resend").fadeIn();
    _form$
        .find("div.sms-resend .button_resend")
        .off("click")
        .on("click", function () {
            _form$.find(sendSmsSelector).trigger("click");
        });
}

function sendAjaxRequest(sender$, form$, $url, $method, $data, onDone) {
    $.ajax({
        url: $url,
        method: $method || "post",
        cache: false,
        async: true,
        data: $data,
        processData: false,
        contentType: false,
        xhrFields: {
            withCredentials: true
        },
        crossDomain: true,
        beforeSend: function () {
            form$.find("input").attr("disabled", "disabled");
            form$.find("button").attr("disabled", "disabled");
            form$.find(".help-block-error").html("");
            if (sender$) {
                sender$.find(".loading").remove();
                sender$.append("<div class='loading'></div>");
            }
        }
    })
        .done(function (response) {
            form$.find("input").removeAttr("disabled");
            form$.find("button").removeAttr("disabled");
            if (sender$) {
                sender$.find(".loading").remove();
            }
            console.log(response);
            if (onDone) {
                onDone(response);
            }
        })
        .fail(function (xhr) {
            console.log("network error");
            form$.find("input").removeAttr("disabled");
            form$.find("button").removeAttr("disabled");
            if (sender$) {
                sender$.find(".loading").remove();
            }
            form$
                .find(".help-block-error:visible")
                .last()
                .html("Произошла непредвиденная ошибка");
        });
}

function initMapCard() {
    $("#formMapCard button[type='submit']").on("click", function (e) {
        var _this = $(this);
        var form$ = _this.closest("form");
        var attrName = "CardForm[oldCard]";
        e.preventDefault();

        var onDone = function (response) {
            if (response.success === true) {
                location.reload();
            } else {
                displayResponseErrors(response, "CardForm", form$);
            }
        };

        var data = new FormData();
        data.set(attrName, form$.find("[name='" + attrName + "']").val());
        data.set("_csrf", form$.find("[name='_csrf']").val());

        sendAjaxRequest(_this, form$, form$.attr("action"), "post", data, onDone);
    });
}

/**
 * Авторизация: вкладки «По коду» (SMS / Telegram / Max через pz-tickets + pz-auth) и «По паролю» (pz-auth).
 */
var AUTH_TAB_STORAGE_KEY = "pzAuthTab";
var AUTH_CODE_STORAGE_PREFIX = "pzAuthCode:";
// Код в pz-api действует 15 минут
var AUTH_CODE_LIFETIME_MS = 15 * 60 * 1000;
var AUTH_CODE_CHANNEL_LABELS = {
    SmsRu: "SMS",
    Telegram: "Telegram",
    Max: "Max"
};

// Вызов после объявления констант выше: var поднимается без значения, и раньше они были бы undefined
initAuth();

function storageGet(key) {
    try {
        var value = window.localStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    } catch (e) {
        return null;
    }
}

function storageSet(key, value) {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
    }
}

function storageRemove(key) {
    try {
        window.localStorage.removeItem(key);
    } catch (e) {
    }
}

/**
 * Российский номер телефона -> +7XXXXXXXXXX, иначе null
 */
function normalizeAuthPhone(value) {
    var digits = (value || "").replace(/[\s()\-]/g, "");
    var match = digits.match(/^(\+7|7|8)?(\d{10})$/);
    return match ? "+7" + match[2] : null;
}

function formatAuthPhone(phone) {
    var d = phone.replace(/\D/g, "").slice(1);
    return "+7 (" + d.substr(0, 3) + ") " + d.substr(3, 3) + "-" + d.substr(6, 2) + "-" + d.substr(8, 2);
}

function localizeAuthCodeError(message) {
    if (!message) {
        return "Произошла непредвиденная ошибка";
    }
    if (message.indexOf("code is wrong") !== -1) {
        return "Неверный код";
    }
    if (message.indexOf("expired") !== -1) {
        return "Срок действия кода истёк, запросите новый";
    }
    if (message.indexOf("No such user") !== -1) {
        return "Пользователь не найден, запросите код ещё раз";
    }
    if (message.indexOf("CodeMaxRepeats") !== -1 || message.indexOf("MaxRepeats") !== -1) {
        return "Превышено число попыток, попробуйте позже";
    }
    if (message.indexOf("CodeSendInterval") !== -1) {
        return "Код уже отправлен, подождите перед повторной отправкой";
    }
    return message;
}

function ticketsApiError(xhr) {
    var response = xhr && xhr.responseJSON;
    if (response) {
        return localizeAuthCodeError(response.ClientReadableExceptionMessage || response.ExceptionMessage);
    }
    return "Сервис временно недоступен, попробуйте позже";
}

function initAuth() {
    var modal$ = $("#authModal");
    if (!modal$.length) {
        return;
    }

    var codeForm$ = $("#authCodeForm");
    var passwordForm$ = $("#authPasswordForm");
    var ticketsHost = modal$.data("tickets-host");
    var authHost = modal$.data("auth-host");
    var redirectUrl = modal$.data("redirect-url");
    var resendTimeoutMs = (parseInt(modal$.data("resend-timeout"), 10) || 60) * 1000;
    var timerId = null;

    var phoneStep$ = codeForm$.find("[data-step='phone']");
    var codeStep$ = codeForm$.find("[data-step='code']");
    var phoneInput$ = $("#authcode-phone");
    var phoneError$ = phoneInput$.closest(".form-group").find(".help-block-error");
    var codeInput$ = $("#authcode-code");
    var codeError$ = codeInput$.closest(".form-group").find(".help-block-error");
    var channels$ = codeForm$.find(".auth-code-channels");
    var sendButton$ = codeForm$.find(".auth-code-send");
    var agree$ = $("#authCodeAgree");
    var botLink = null;
    var qrToggle$ = codeStep$.find(".auth-code-qr-toggle");
    var qr$ = codeStep$.find("#authBotQr");
    var qrImage$ = qr$.find(".auth-code-qr-image");
    var qrError$ = qr$.find(".auth-code-qr-error");

    function resetBotQr() {
        qr$.addClass("hide");
        qrImage$.empty();
        qrError$.addClass("hide").text("");
        qrToggle$.attr("aria-expanded", "false").text("Показать QR-код");
    }

    qrToggle$.on("click", function () {
        if (!botLink) {
            return;
        }
        if (!qr$.hasClass("hide")) {
            resetBotQr();
            return;
        }

        qr$.removeClass("hide");
        qrToggle$.attr("aria-expanded", "true").text("Скрыть QR-код");
        try {
            new window.QRCode(qrImage$[0], {
                text: botLink,
                width: 224,
                height: 224,
                correctLevel: window.QRCode.CorrectLevel.M
            });
        } catch (e) {
            qrImage$.empty();
            qrError$.removeClass("hide").text("Не удалось показать QR-код. Воспользуйтесь кнопкой «Открыть бота».");
        }
    });

    // --- вкладки ---

    function switchTab(tab) {
        modal$.find("input[name='auth-tab'][value='" + tab + "']").prop("checked", true);
        codeForm$.toggleClass("hide", tab !== "code");
        passwordForm$.toggleClass("hide", tab !== "password");
        storageSet(AUTH_TAB_STORAGE_KEY, tab);
        if (tab === "code") {
            restoreCodeState();
        }
    }

    modal$.find("input[name='auth-tab']").on("change", function () {
        switchTab($(this).val());
    });

    // --- каналы доставки кода ---

    function renderChannels(ways) {
        var select$ = channels$.find("select").empty();
        $.each(ways, function (i, way) {
            select$.append($("<option></option>").val(way).text(AUTH_CODE_CHANNEL_LABELS[way]));
        });
        channels$.toggleClass("hide", ways.length < 2);
    }

    function loadChannels() {
        renderChannels(["SmsRu"]);
        $.ajax({
            url: ticketsHost + "/v2/auth/sms/get-active",
            method: "get",
            cache: false
        }).done(function (response) {
            var ways = ((response && response.Data && response.Data.SmsDeliveryWays) || []).filter(function (way) {
                return AUTH_CODE_CHANNEL_LABELS.hasOwnProperty(way);
            });
            if (ways.length) {
                renderChannels(ways);
            }
        });
    }

    function selectedChannel() {
        return channels$.find("select").val() || "SmsRu";
    }

    // --- состояние отправленного кода (переживает переключение вкладок и перезагрузку) ---

    function stateKey(phone) {
        return AUTH_CODE_STORAGE_PREFIX + phone;
    }

    function getState(phone) {
        var state = phone ? storageGet(stateKey(phone)) : null;
        if (state && Date.now() - state.sentAt > AUTH_CODE_LIFETIME_MS) {
            storageRemove(stateKey(phone));
            return null;
        }
        return state;
    }

    function stopTimer() {
        if (timerId) {
            clearInterval(timerId);
            timerId = null;
        }
    }

    function runTimer(state) {
        stopTimer();
        var tick = function () {
            var left = Math.ceil((state.sentAt + resendTimeoutMs - Date.now()) / 1000);
            var canResend = left <= 0;
            codeStep$.find(".auth-code-timer").toggleClass("hide", canResend);
            codeStep$.find(".auth-code-resend").toggleClass("hide", !canResend);
            codeStep$.find(".auth-code-timer-value").text(Math.max(left, 0));
            if (canResend) {
                stopTimer();
            }
        };
        tick();
        timerId = setInterval(tick, 1000);
    }

    function showPhoneStep() {
        stopTimer();
        botLink = null;
        resetBotQr();
        codeStep$.find(".auth-code-bot").addClass("hide");
        codeStep$.find(".auth-code-bot-link").attr("href", "#");
        codeStep$.addClass("hide");
        phoneStep$.removeClass("hide");
    }

    function showCodeStep(phone, state) {
        phoneStep$.addClass("hide");
        codeStep$.removeClass("hide");
        codeStep$.find(".auth-code-sent-to").text(
            "Код отправлен на " + formatAuthPhone(phone) + " через " + (AUTH_CODE_CHANNEL_LABELS[state.channel] || "SMS")
        );
        botLink = (state.channel === "Telegram" || state.channel === "Max") && state.botLink ? state.botLink : null;
        resetBotQr();
        codeStep$.find(".auth-code-bot").toggleClass("hide", !botLink);
        codeStep$.find(".auth-code-bot-link").attr("href", botLink || "#");
        codeError$.html("");
        runTimer(state);
        codeInput$.trigger("focus");
    }

    function restoreCodeState() {
        var phone = normalizeAuthPhone(phoneInput$.val());
        var state = getState(phone);
        if (state) {
            showCodeStep(phone, state);
        } else {
            showPhoneStep();
        }
    }

    // --- шаг 1: отправка кода ---

    function updateSendButton() {
        sendButton$.prop("disabled", !agree$.is(":checked"));
    }

    agree$.on("change", updateSendButton);

    phoneInput$.on("input", function () {
        phoneError$.html("");
    });

    phoneInput$.on("blur", function () {
        var phone = normalizeAuthPhone(phoneInput$.val());
        if (phone) {
            phoneInput$.val(formatAuthPhone(phone));
        }
    });

    function sendCode(channel) {
        var phone = normalizeAuthPhone(phoneInput$.val());
        if (!phone) {
            phoneError$.html("Неверный формат телефона");
            return;
        }

        var existing = getState(phone);
        if (existing && Date.now() - existing.sentAt < resendTimeoutMs) {
            // код уже отправлен и повторная отправка ещё недоступна
            showCodeStep(phone, existing);
            return;
        }

        sendButton$.prop("disabled", true);
        $.ajax({
            url: ticketsHost + "/v2/auth/signin-register/sms",
            method: "post",
            contentType: "application/json",
            dataType: "json",
            data: JSON.stringify({
                MobilePhone: phone,
                CityId: String(modal$.data("city-id") || ""),
                CrmSystemIdList: modal$.data("crm-ids") || [],
                SmsDeliveryWay: channel
            })
        }).done(function (response) {
            var data = (response && response.Data) || {};
            if (!response || !response.Success || data.success === false) {
                var errors = data.errors && data.errors.length ? data.errors.join(", ") : null;
                phoneError$.html(localizeAuthCodeError(errors || (response && response.ExceptionMessage)));
                return;
            }
            var state = {channel: channel, sentAt: Date.now(), botLink: data.additionalServiceLink || null};
            storageSet(stateKey(phone), state);
            showCodeStep(phone, state);
        }).fail(function (xhr) {
            (codeStep$.hasClass("hide") ? phoneError$ : codeError$).html(ticketsApiError(xhr));
        }).always(updateSendButton);
    }

    sendButton$.on("click", function (e) {
        e.preventDefault();
        sendCode(selectedChannel());
    });

    codeStep$.find(".auth-code-resend-link").on("click", function (e) {
        e.preventDefault();
        var phone = normalizeAuthPhone(phoneInput$.val());
        var state = getState(phone);
        storageRemove(stateKey(phone));
        sendCode(state ? state.channel : selectedChannel());
    });

    codeStep$.find(".auth-code-change-link").on("click", function (e) {
        e.preventDefault();
        storageRemove(stateKey(normalizeAuthPhone(phoneInput$.val())));
        showPhoneStep();
        phoneInput$.trigger("focus");
    });

    // --- шаг 2: проверка кода в pz-auth ---

    codeInput$.on("input", function () {
        codeError$.html("");
    });

    codeForm$.on("submit", function (e) {
        e.preventDefault();
        if (codeStep$.hasClass("hide")) {
            if (!sendButton$.prop("disabled")) {
                sendCode(selectedChannel());
            }
            return;
        }

        var phone = normalizeAuthPhone(phoneInput$.val());
        var code = $.trim(codeInput$.val());
        if (!code) {
            codeError$.html("Введите код");
            return;
        }

        var rememberMe = $("#authCodeRemember").is(":checked");
        var data = new FormData();
        data.set("SmsForm[phone]", phone);
        data.set("SmsForm[code]", code);
        data.set("SmsForm[rememberMe]", rememberMe ? 1 : 0);

        sendAjaxRequest(codeForm$.find("button[type='submit']"), codeForm$, authHost + "/auth/smsauth", "post", data, function (response) {
            if (response.success === true) {
                storageRemove(stateKey(phone));
                setAuthCookie(response.token, rememberMe);
                window.location.href = redirectUrl;
            } else {
                codeError$.html(localizeAuthCodeError(response.errors && response.errors[0]));
            }
        });
    });

    // --- вкладка «По паролю» ---

    var passwordError$ = $("#authform-password").closest(".form-group").find(".help-block-error");

    passwordForm$.find("#authform-login, #authform-password").on("input", function () {
        passwordError$.html("");
    });

    passwordForm$.on("submit", function (e) {
        e.preventDefault();
        var login = $.trim($("#authform-login").val());
        var password = $("#authform-password").val();
        var rememberme = $("#authform-rememberme").is(":checked");
        signIn(normalizeAuthPhone(login) || login, password, rememberme, passwordForm$, passwordError$);
    });

    modal$.on("show.bs.modal", function () {
        switchTab(storageGet(AUTH_TAB_STORAGE_KEY) === "password" ? "password" : "code");
    });

    modal$.on("hidden.bs.modal", stopTimer);

    loadChannels();
    updateSendButton();
}

function initCompleteRegistration() {
    var modal$ = $("#completeRegistrationModal");
    if (!modal$.length) {
        return;
    }

    var form$ = $("#completeRegistrationForm");
    modal$.modal("show");

    form$.on("submit", function (e) {
        e.preventDefault();
        sendAjaxRequest(form$.find("button[type='submit']"), form$, form$.attr("action"), "post", new FormData(form$[0]), function (response) {
            if (response.success === true) {
                window.location.reload();
            } else {
                displayResponseErrors(response, "CompleteRegistrationForm", form$);
            }
        });
    });
}

function setAuthCookie(token, rememberMe) {
    if (rememberMe) {
        $.cookie('i', token, {expires: 30, path: '/'});
    } else {
        $.cookie('i', token, {path: '/'});
    }
}

function displayResponseErrors(response, formName, form$) {
    if (response.errors) {
        $.each(response.errors, function (ind, val) {
            var errorMessage = val[0];
            var control$ = form$.find("[name='" + formName + "[" + ind + "]']");
            if (control$.length) {
                control$
                    .closest("div.form-group")
                    .find(".help-block-error")
                    .html(errorMessage);
            }
        });
    } else if (response.error) {
        form$
            .find(".help-block-error:visible")
            .last()
            .html(response.error);
    } else {
        form$
            .find(".help-block-error:visible")
            .last()
            .html("Произошла непредвиденная ошибка");
    }
}

function signIn(login, password, rememberme, form$, $errorField) {
    var redirectUrl = form$.data("redirect-url");
    var authUrl =
        form$.data("auth-host") + "/auth/async?redirect-url=" + redirectUrl;
    var data = new FormData();
    data.set("AuthForm[username]", login);
    data.set("AuthForm[password]", password);
    data.set("AuthForm[rememberMe]", rememberme ? 1 : 0);

    var localizeMessage = function (message) {
        var result = "Ошибка";
        if (message) {
            if (message === "User not active") {
                result = "Учетная запись не активирована";
            } else {
                var expandedMessage = message.split(" ");
                if (expandedMessage[0] === "Invalid") {
                    result = "Неверный пароль";
                }
                if (expandedMessage[0] === "No") {
                    result = "Пользователь не найден";
                }
            }
        }
        return result;
    };

    if (login && password) {
        var onDone = function (response) {
            if (response.success === true) {
                setAuthCookie(response.token, rememberme);
                window.location.href = redirectUrl;
            } else {
                if (response.errors) {
                    var errorMessage = localizeMessage(response.errors[0]);
                    if ($errorField) {
                        $errorField.html(errorMessage);
                    }
                }
            }
        };

        sendAjaxRequest(null, form$, authUrl, "post", data, onDone);
    } else {
        if ($errorField) {
            $errorField.html("Необходимо заполнить логин и пароль");
        }
    }
}

$(document).on("click", ".user-logout", function () {
    $.cookie('i', null, {path: '/'});
});

$('.carousel-stacked').on('init', function (e, slick) {
    let $target = $(e.currentTarget);

    $target.removeClass('carousel-stacked__rendering');
}).slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    dots: false,
    focusOnSelect: true,
    lazyLoad: 'ondemand',
    // centerMode: true,
    // centerPadding: '0px',
    prevArrow: "<a class='slick-arrow_dots slick-arrow_prev glyphicon glyphicon-menu-left'></a>",
    nextArrow: "<a class='slick-arrow_dots slick-arrow_next glyphicon glyphicon-menu-right'></a>",
    appendArrows: $('.carousel-stacked'),
});

function carouselFilmsInit() {
    let slide = 0;

    $('.carousel-films').on('init', function (e, slick) {
        let $target = $(e.currentTarget);
        $target.find('.slick-arrow_prev').appendTo($target.find('.slick-dots'));
        $target.find('.slick-arrow_next').appendTo($target.find('.slick-dots'));
    }).on('afterChange', function (event, slick, currentSlide) {
        if (slide !== currentSlide) {
            var items = $('.carousel-films').find('.slick-slide:not(.slick-active)');
            items.each(function (indx, element) {
                var item = $(element).find('.jwplayer').attr('id');
                jwplayer(item).play(false);
            });
            slide = currentSlide;
        }
    }).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        focusOnSelect: true,
        lazyLoad: 'ondemand',
        adaptiveHeight: true,
        // centerMode: true,
        // centerPadding: '0px',
        prevArrow: "<li class='slick-arrow_dots slick-arrow_prev glyphicon glyphicon-chevron-left'></li>",
        nextArrow: "<li class='slick-arrow_dots slick-arrow_next glyphicon glyphicon-chevron-right'></li>",
    });
}

carouselFilmsInit();

function hideUnnecessaryItems(container) {
    let $container = $(container);
    let items = $container.children();
    items.slice(1).each((i, item) => {
        let $item = $(item);
        $item.show();
        $item.css("display", 'flex')
        let lastItemRight = $item.offset().left + $item.width()
        let leftForNavbarRight = $('.navbar .navbar-right').offset().left
        if (lastItemRight > leftForNavbarRight) {
            $item.hide();
        }
    });
}

$(window).resize((e) => {
    //locateSubnavMenu();
    locateMainPageWrapper();
    hideUnnecessaryItems($('.navbar .navbar-category'));
    setStillSise();
    messageModalStyles();
});

function locateSubnavMenu() {
    //$(".navbar .navbar-category li .subnav").css("top", `${+$(".navbar").css("height").slice(0, -2)}px`);
}

function locateMainPageWrapper() {
    let navbarHeight = $(".navbar").css("height");
    $(".content-wrapper").css({
        top: navbarHeight,
        minHeight: `calc(100vh - ${navbarHeight}`,
    });
}

//locateSubnavMenu();
locateMainPageWrapper();
hideUnnecessaryItems($('.navbar .navbar-category'));
$('.cookie-notice').find('.close-notice').on('click', function () {
    $.cookie('cookie-notice', '1', {path: '/'});
    $('.cookie-notice').remove();

    return false;
});

function setStillSise() {
    let dropdown = $('.navbar-category li.nav-item .still-dropdown');
    let indent = 5;
    let navbarLength = $('.navbar')[0].offsetWidth;
    let dropdownWidth = 100 * (navbarLength) / window.innerWidth - 2 * indent;
    let dropdownLeft = 100 * $('.navbar').offset().left / window.innerWidth + indent;
    dropdown.css('width', `${dropdownWidth}vw`);
    let navbarHeight = $(".navbar").css("height");
    dropdown.css('left', `${dropdownLeft}vw`);
    dropdown.css('top', navbarHeight);
    if (dropdownWidth < 75) {
        dropdown.css('grid-template-columns', '1fr 1fr');
    }
}

setStillSise();

$(".still").click(function (e) {
    $(this).toggleClass("active");
}).hover(function (e) {
    e.preventDefault();
    if (!$(this).hasClass("active")) {
        $(this).addClass("active");
    }
}, function (e) {
    e.preventDefault();
    if ($(this).hasClass("active")) {
        $(this).removeClass("active");
    }
})

function messageModalStyles() {
    let modal = $("#messageModal");
    let imageContainer = modal.find(".message-modal__image");
    let messageContainer = modal.find(".message-modal__container");
    let title = modal.find(".message-modal__title");
    let btns = modal.find(".message-modal__buttons");
    let containerHeight = messageContainer.height();
    let gaps = messageContainer.css("gap") ? +messageContainer.css("gap").slice(0, -2) * 2 : 0;
    let imageHeight = (containerHeight - title.height() - btns.height() - gaps) / containerHeight * 100;
    imageContainer.css("max-height", `${imageHeight}%`)

    messageModalTextStyles();
}

$(document).ready(function(){
    messageModalStyles();
});

function messageModalTextStyles(){
    let modal = $("#messageModal");
    let container = modal.find(".message-modal__container");
    let title = modal.find(".message-modal__title");
    let btns = modal.find(".message-modal__buttons");
    let btnTop = btns.length ? btns.offset().top : 0;
    let btnBottom = btns.height() + btnTop;
    let containerInnerBottom = container.length ? container.offset().top + container.innerHeight() : 0;
    let titleFZ = title.css("font-size") ? +title.css("font-size").slice(0, -2) : 0;
    let modalContent = modal.find(".modal-content");
    let modalBottom = modalContent.length ? modalContent.offset().top + modalContent.height() : 0;
    let modalMaxBottom = window.innerHeight * 0.75 + (modalContent.length ? modalContent.offset().top : 0);

    let calculateDiff = function() {
        return btnBottom - containerInnerBottom;
    }

    let onChangeSize = function () {
        title.css("font-size", `${titleFZ}px`);
        btnTop = btns.length ? btns.offset().top : 0;
        btnBottom = btns.height() + btnTop;
        containerInnerBottom = container.length ? container.offset().top + container.innerHeight() : 0;
        modalBottom = modalContent.length ? modalContent.offset().top + modalContent.height() : 0;
    }

    if (window.innerWidth > 1200) {
        while(titleFZ < 35) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth > 991 && window.innerWidth < 1200) {
        while(titleFZ < 32) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth >= 768 && window.innerWidth <= 991) {
        while(titleFZ < 30) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth <= 767) {
        while(titleFZ < 25) {
            titleFZ++;
            onChangeSize();
        }
    }

    if(window.innerWidth <= 480) {
        while(titleFZ < 20) {
            titleFZ++;
            onChangeSize();
        }
    }

    while(calculateDiff() > 0 && modalBottom >= modalMaxBottom && titleFZ > 10) {
        titleFZ--;
        onChangeSize();
    }
}


// WEBPACK FOOTER //
// ./frontend/web/js/app.js